import request from './request'


const formMaintenanceApi = {
//  获取页面配置信息
  getPageConfig(data, u) {
    var url
    if (u) {
      url = u + '/GetPageInfo'
    } else {
      url = '/GetPageInfo'
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 添加
  add(data, u) {
    return request({
      url: u + '/add',
      method: 'post',
      data: data
    })
  },
  // 通过id获取信息
  getById(data, u, id) {
    var url
    if (u) {
      url = u + '/GetPageControlsConfigList?id=' + id
    } else {
      url = '/GetModeleByKey?PID=' + id
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 通过id数组删除信息
  delByIds(data, u) {
    var url
    if (u) {
      url = u + '/RemoveByKeyList'
    } else {
      url = '/RemoveByKeyList'
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 修改
  update(data, u) {
    return request({
      url: u + '/update',
      method: 'post',
      data
    })
  },
  // 获取所有
  getList(data, u) {
    var url
    if (u) {
      url = u + '/GetList'
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 获取所有
  getPageByDics(data, u) {
    var url
    if (u) {
      url = u + '/GetPageByDics'
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 获取弹窗配置
  getPopPageConfig(data) {
    return request({
      url: '/tsystemSet/GetPageInfo',
      method: 'post',
      data
    })
  },
  // 新增字段 'http://192.168.1.107:16000/api/tsystemset/add',
  addFiled(data) {
    return request({
      url: '/tsystemset/add',
      method: 'post',
      data: data
    })
  },
  // 修改字段
  updateFiled(data) {
    return request({
      url: '/tsystemSet/update',
      method: 'post',
      data: data
    })
  },
  //  删除字段
  delFiled(data, id) {
    return request({
      url: '/tsystemSet/DeleteByKey?ID=' + id,
      method: 'post',
      data: data
    })
  },
  //  删除一组字段
  delFileds(data) {
    return request({
      url: '/tsystemSet/RemoveByKeyList',
      method: 'post',
      data: data
    })
  }
}

export default formMaintenanceApi
